import React, { useState, useEffect } from 'react'
import { Collapse } from '@mui/material'
import { TextField } from '../../Base/Form/index.js'
import * as lib from '../../../../js/lib/lib.js'

const DriverFields = ({ control }) => {
  const { dictionary } = window.modifyData
  const [toggleCollapse, setToggleCollapse] = useState(false)

  const handleCollapseClick = () => {
    if (lib.scrDevices()) {
      setToggleCollapse((old) => !old)
    }
  }

  useEffect(() => {
    const handleResize = () => {
      if (!lib.scrDevices()) {
        setToggleCollapse(true)
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <>
      <div className="s-booking-form__form-group">
        <div className="row" onClick={handleCollapseClick}>
          <div className="col-lg-6 mb-24 d-flex align-items-center justify-content-between">
            <span className="s-booking-form__form-group__title">
              {dictionary.driverDetailsTitle}
            </span>
            <div className="d-lg-none ">
              <i
                className={`icon-arrow-down arrow ${
                  toggleCollapse ? 'open' : ''
                }`}
              />
            </div>
          </div>
        </div>

        <Collapse in={toggleCollapse}>
          <div className="row">
            <div className="col-lg-6 mb-24">
              <TextField
                name="firstName"
                label={dictionary.firstNameLabel}
                control={control}
                disabled
              />
            </div>
            <div className="col-lg-6 mb-24">
              <TextField
                name="lastName"
                label={dictionary.lastNameLabel}
                control={control}
                disabled
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 mb-24">
              <TextField
                name="email"
                label={dictionary.emailLabel}
                control={control}
                disabled
              />
            </div>
            <div className="col-lg-6 mb-24">
              <div className="s-modify-form__phone">
                <TextField
                  name="countryCode"
                  label={dictionary.countryCodeLabel}
                  control={control}
                  disabled
                />
                <TextField
                  name="phone"
                  label={dictionary.phoneLabel}
                  control={control}
                  disabled
                />
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </>
  )
}

export default DriverFields
